/**
 * Format a Fast CAT run time in seconds for display.
 * - Show 3 decimals if the thousandths digit is non-zero (e.g. 7.793)
 * - Otherwise show 2 decimals (e.g. 7.79, 7.70)
 * - Minimum 2 decimals so it always reads as a time
 *
 * Examples:
 *   formatTime(7.793) → "7.793"
 *   formatTime(7.79)  → "7.79"
 *   formatTime(7.79)  → "7.79"   (when stored as 7.790)
 *   formatTime(7.7)   → "7.70"
 *   formatTime(0)     → "—"
 */
export function formatTime(seconds: number | string | null | undefined): string {
  if (seconds == null) return "—";
  const n = typeof seconds === "string" ? parseFloat(seconds) : seconds;
  if (!isFinite(n) || n <= 0) return "—";
  const fixed3 = n.toFixed(3);
  return fixed3.endsWith("0") ? n.toFixed(2) : fixed3;
}
